/** @flow */

import {
  GetNurseDeclinedReasonsList,
  GetNurseDeclinedReasonsListSuccess,
  GetNurseDeclinedReasonsListError,
  GetNurseDeclinedReason,
  GetNurseDeclinedReasonSuccess,
  GetNurseDeclinedReasonError,
  ResetNurseDeclinedReason,
  GetNurseDeclinedReasonSchema,
  GetNurseDeclinedReasonSchemaSuccess,
  GetNurseDeclinedReasonSchemaError,
  SetNurseDeclinedReasonsEnabled,
  SetNurseDeclinedReasonsStatus,
  SetShowAddNurseDeclinedReasonModal,
  SetShowEditNurseDeclinedReasonModal,
  AddNurseDeclinedReason,
  AddNurseDeclinedReasonSuccess,
  AddNurseDeclinedReasonError,
  UpdateNurseDeclinedReason,
  UpdateNurseDeclinedReasonSuccess,
  UpdateNurseDeclinedReasonError,
} from "@modules/service/constants/actions";
import * as nurseDeclinedReducers from "./reducers";
import initialState from "./state";
import type { NurseDeclinedReasonsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: NurseDeclinedReasonsState = initialState,
  action: Object,
): NurseDeclinedReasonsState => {
  const act = {
    [UpdateNurseDeclinedReason]: nurseDeclinedReducers.onUpdateNurseDeclinedReason,
    [UpdateNurseDeclinedReasonSuccess]: nurseDeclinedReducers.onUpdateNurseDeclinedReasonSuccess,
    [UpdateNurseDeclinedReasonError]: nurseDeclinedReducers.onUpdateNurseDeclinedReasonError,

    [AddNurseDeclinedReason]: nurseDeclinedReducers.onAddNurseDeclinedReason,
    [AddNurseDeclinedReasonSuccess]: nurseDeclinedReducers.onAddNurseDeclinedReasonSuccess,
    [AddNurseDeclinedReasonError]: nurseDeclinedReducers.onAddNurseDeclinedReasonError,

    [GetNurseDeclinedReasonsList]: nurseDeclinedReducers.onGetNurseDeclinedReasonsList,
    [GetNurseDeclinedReasonsListSuccess]:
      nurseDeclinedReducers.onGetNurseDeclinedReasonsListSuccess,
    [GetNurseDeclinedReasonsListError]: nurseDeclinedReducers.onGetNurseDeclinedReasonsListError,

    [GetNurseDeclinedReason]: nurseDeclinedReducers.onGet,
    [GetNurseDeclinedReasonSuccess]: nurseDeclinedReducers.onGetSuccess,
    [GetNurseDeclinedReasonError]: nurseDeclinedReducers.onGetError,
    [ResetNurseDeclinedReason]: nurseDeclinedReducers.onResetNurseDeclinedReason,

    [GetNurseDeclinedReasonSchema]: nurseDeclinedReducers.onGetSchema,
    [GetNurseDeclinedReasonSchemaSuccess]: nurseDeclinedReducers.onGetSchemaSuccess,
    [GetNurseDeclinedReasonSchemaError]: nurseDeclinedReducers.onGetSchemaError,

    [SetNurseDeclinedReasonsEnabled]: nurseDeclinedReducers.onSetEnabled,
    [SetNurseDeclinedReasonsStatus]: nurseDeclinedReducers.onSetStatus,

    [SetShowAddNurseDeclinedReasonModal]: nurseDeclinedReducers.onSetShowAddModal,
    [SetShowEditNurseDeclinedReasonModal]: nurseDeclinedReducers.onSetShowEditModal,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
